export const visit = (vm, at) => {
vm(require("pricing-pages-ui/lang/en.lyaml"));
vm(require("foundations-components/lang/en.lyaml"));
vm(require("feature-monetization/lang/en.lyaml"));
vm(require("usage-based-billing-components-lib/lang/CreditEstimator/en.lyaml"));
vm(require("usage-based-billing-components-lib/lang/en.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/header/en.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/marketing-hub/en.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card/en.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card-copy/en.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card-price/en.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card-term/en.lyaml"));
at({ "en": { "ui": { "UILoadingSpinner": { "busyText": "Loading", "completedText": "Loaded" } }, "publicPricingPage": { "windowTitles": { "default": "Pricing | HubSpot" } } } });
};